import { render, staticRenderFns } from "./vFormGoToComponent.vue?vue&type=template&id=21d7978d&"
import script from "./vFormGoToComponent.vue?vue&type=script&lang=js&"
export * from "./vFormGoToComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports